<template>
  <div :class="$style.loaderContainer">
    <svg
      :class="$style.loader"
      height="1024.000000pt"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 1024.000000 1024.000000"
      version="1.0"
      width="1024.000000pt"
      xmlns="http://www.w3.org/2000/svg"
    >
      <metadata>
        Created by potrace 1.14, written by Peter Selinger 2001-2017
      </metadata>
      <g
        fill="#FFFFFF"
        stroke="none"
        transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"
      >
        <path
          d="M1923 8933 c-247 -269 -1918 -2107 -1920 -2112 -1 -3 449 -501 1000
            -1106 l1002 -1100 768 -3 c422 -1 767 0 767 3 0 3 -310 346 -689 763 l-689
            757 3732 5 3732 5 307 338 308 337 -1013 1115 -1013 1115 -3092 0 -3091 0
            -109 -117z"
        />
        <path
          d="M4561 5133 c8 -9 317 -350 688 -757 l674 -741 -1508 -3 c-914 -1
            -1505 -6 -1503 -11 4 -13 2209 -2433 2212 -2429 2 2 803 883 1781 1958 978
            1075 1787 1965 1798 1978 l20 22 -2087 0 c-1955 0 -2088 -1 -2075 -17z"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Loader'
};
</script>

<style module>
.loader-container {
  align-items: center;
  display: flex;
  height: calc(100vh - 100px);
  justify-content: center;
}

.loader {
  animation: blinker 2s linear infinite;
  height: 64px;
  text-align: center;
  width: 64px;
}

@keyframes blinker {
  0% {
    opacity: 1;
  }

  15% {
    opacity: 0.7;
  }

  35% {
    opacity: 1;
  }
}
</style>
